// extracted by mini-css-extract-plugin
module.exports = {"container":"Countdown-modulecontainer2-e","active":"Countdown-moduleactivejtg"};